import ReviewScoreVisualisation from './ReviewScoreVisualisation';
import React from 'react';
import { HashLink } from 'react-router-hash-link';

/**
 * A visualisation of a fishery review score with the number of reviews next to it
 */
export default function CountedReviewsScore({
  score,
  numReviews,
  numRatings,
  reviewsAnchor = null,
}) {
  const reviewsText = `${
    numRatings ? `${numRatings} Rating${numRatings !== 1 ? 's' : ''} |` : ''
  } ${numReviews} Review${numReviews !== 1 ? 's' : ''}`;

  return (
    <div
      style={{
        display: 'flex',
        gap: '0.5rem',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <ReviewScoreVisualisation score={score} small />
      <span
        className='gSemiBold fs-16 display-inline-block'
        style={{ whiteSpace: 'nowrap' }}
      >
        {reviewsAnchor ? (
          <HashLink
            to={reviewsAnchor}
            className='sb-blue txt-underline'
            replace
          >
            {reviewsText}
          </HashLink>
        ) : (
          <span>{reviewsText}</span>
        )}
      </span>
    </div>
  );
}
